import React from "react";
import "./SearchFilterContainer.scss";

export const SearchFilterContainer: React.FC = ({ children }) => {
  return <div className="search-filter-container">{children}</div>;
};
